/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  headline: 'headline',
  merchant: 'merchant',
  user: 'user',
  password: 'password',
  submit: 'submit',
  forgotPassword: 'forgotPassword',
  agency: 'agency',
  email: 'email',
  forgotPasswordSuccessText: 'forgotPasswordSuccessText',
  forgotPasswordFailText: 'forgotPasswordFailText',
  requiredField: 'requiredField'
}; export default Keys;